(() => {
  'use strict';
  document.documentElement.classList.replace('no-js','js');
  const configElement = document.getElementById('TaplyConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const live = document.querySelector('[data-live-region]');
  let cartBusy = false;
  let cartOpener = null;
  let changeQueue = Promise.resolve();
  function publish(name,data) {
    try { if(!config.customAnalytics || window.TaplyPrivacy?.allowed('analytics') !== true || typeof window.Shopify?.analytics?.publish !== 'function') return;
    Promise.resolve(window.Shopify.analytics.publish('taply:'+name,data)).catch(()=>{}); } catch {}
  }
  const announce = message => { if (live) live.textContent = message; };
  const showError = (element, message) => { if (element) { element.textContent = message; element.hidden = false; } };
  function openDrawer(opener) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || typeof drawer.showModal !== 'function') { location.assign(config.routes.cart); return; }
    cartOpener = opener || document.activeElement;
    if (!drawer.open) drawer.showModal();
  }
  function replaceCart(html, open = true) {
    if (typeof html !== 'string') return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    const old = document.getElementById('CartDrawer');
    if (!fresh || !old) return false;
    const wasOpen = old.open;
    if (wasOpen) old.close();
    old.replaceWith(fresh);
    document.dispatchEvent(new CustomEvent('taply:cart-updated'));
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = fresh.dataset.itemCount; });
    if (open || wasOpen) openDrawer(cartOpener);
    return true;
  }
  async function refreshCart() {
    const url = new URL(config.routes.cart, location.origin);
    url.searchParams.set('sections', 'cart-drawer');
    const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error(config.strings.cartError);
    const data = await response.json();
    if (!replaceCart(data['cart-drawer'])) throw new Error(config.strings.cartError);
  }
  function purchaseControls(section, form, selector, stickySelector) {
    const controls = [...form.querySelectorAll(selector)];
    controls.push(...section.querySelectorAll(stickySelector));
    return controls;
  }
  function selectedOffer(form) {
    return form.querySelector('.offer-radio:checked');
  }
  function syncSelection(section, form) {
    const choice = selectedOffer(form);
    if (!choice) return;
    const available = choice.dataset.available === 'true' && !choice.disabled;
    const bundle = choice.dataset.bundle === 'true';
    form.querySelectorAll('[data-selected-title]').forEach(el => { el.textContent = choice.dataset.title; });
    form.querySelectorAll('[data-selected-price]').forEach(el => { el.textContent = choice.dataset.price; });
    section.querySelectorAll('[data-sticky-title]').forEach(el => { el.textContent = choice.dataset.title; });
    section.querySelectorAll('[data-sticky-price]').forEach(el => { el.textContent = choice.dataset.price; });
    form.querySelectorAll('[data-button-price]').forEach(el => { el.textContent = available && !cartBusy ? '— '+choice.dataset.price : ''; });
    section.querySelectorAll('[data-sticky-button-price]').forEach(el=>{el.textContent=available&&!cartBusy?'— '+choice.dataset.price:'';});
    section.querySelectorAll('[data-shipping-summary]').forEach(el=>{
      const free=Number(choice.dataset.amount)>=Number(el.dataset.threshold);
      el.classList.toggle('shipping-summary--free',free);
      el.querySelector('[data-shipping-copy]').textContent=free?el.dataset.freeText:el.dataset.paidText;
    });
    const comparison=section.querySelector('[data-mini-comparison]');
    if(comparison)comparison.hidden=Number(choice.dataset.amount)>=Number(comparison.dataset.threshold);
    const handles=(choice.dataset.handles || '').split(',').filter(Boolean);
    const items=handles.map(h=>({h,q:bundle?1:Number(choice.dataset.quantity||1),available}));
    const widget=section.querySelector('[data-dispatch-widget]');
    if(widget)widget.dataset.items=JSON.stringify(items);
    section.dispatchEvent(new CustomEvent('taply:selection-change',{bubbles:true,detail:{items}}));
    form.querySelector('[name="quantity"]').value = choice.dataset.quantity || '1';
    purchaseControls(section,form,'[data-add-button]','[data-sticky-button]').forEach(el => { el.disabled = !available || cartBusy; });
    purchaseControls(section,form,'[data-button-label]','[data-sticky-label]').forEach(el => { el.textContent = available ? (bundle ? config.strings.addBundle : config.strings.add) : config.strings.soldOut; });
  }
  function initProduct(section) {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    section.querySelector('[data-main-variant]')?.addEventListener('change', event => {
      const url = new URL(location.href);
      url.searchParams.set('variant', event.target.value);
      location.assign(url.toString());
    });
    section.addEventListener('change', event => {
      if (event.target.matches('.offer-radio')) { syncSelection(section,event.target.closest('[data-product-form]')); publish('offer_selected',{variant_id:event.target.value,quantity:Number(event.target.dataset.quantity),amount_minor:Number(event.target.dataset.amount),currency:config.currency,bundle:event.target.dataset.bundle==='true'}); }
    });
    section.querySelectorAll('[data-product-form]').forEach(form => syncSelection(section,form));
    const button = section.querySelector('[data-add-button]');
    const sticky = section.querySelector('[data-sticky-buy]');
    if (button && sticky && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('has-sticky-buy');
      let stickyFrame = 0;
      const updateSticky = () => {
        stickyFrame = 0;
        const rect=button.getBoundingClientRect();
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const viewportTop = window.visualViewport?.offsetTop || 0;
        const viewportBottom = viewportTop + viewportHeight;
        const reached=section.querySelector('[data-product-form]').getBoundingClientRect().top < viewportBottom-100;
        const overlayOpen = document.querySelector('dialog[open], .mobile-nav[open]');
        const editing = document.activeElement?.matches('textarea, select, input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), [contenteditable="true"]');
        sticky.hidden = Boolean(overlayOpen || editing || !reached || (rect.top < viewportBottom && rect.bottom > viewportTop));
      };
      const scheduleSticky = () => {
        if (!stickyFrame) stickyFrame = requestAnimationFrame(updateSticky);
      };
      const observer = new IntersectionObserver(scheduleSticky, { threshold: 0 });
      observer.observe(button);
      const overlayObserver = new MutationObserver(scheduleSticky);
      overlayObserver.observe(document.body, {subtree: true, attributes: true, attributeFilter: ['open']});
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky, { passive: true });
      window.visualViewport?.addEventListener('resize', scheduleSticky, { passive: true });
      window.visualViewport?.addEventListener('scroll', scheduleSticky, { passive: true });
      document.addEventListener('focusin', scheduleSticky);
      document.addEventListener('focusout', scheduleSticky);
      updateSticky();
      section._taplyStickyCleanup = () => {
        observer.disconnect();
        overlayObserver.disconnect();
        cancelAnimationFrame(stickyFrame);
        window.removeEventListener('scroll', scheduleSticky);
        window.removeEventListener('resize', scheduleSticky);
        window.visualViewport?.removeEventListener('resize', scheduleSticky);
        window.visualViewport?.removeEventListener('scroll', scheduleSticky);
        document.removeEventListener('focusin', scheduleSticky);
        document.removeEventListener('focusout', scheduleSticky);
      };
    }
  }
  function initGallery(gallery) {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const track = gallery.querySelector('.gallery-track');
    const slides = Array.from(track.children);
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    let index = 0;
    let frame = 0;
    const go = next => {
      next = Math.max(0, Math.min(slides.length - 1, next));
      publish('gallery_interaction',{action:'navigate',index:next});
      track.scrollTo({left: slides[next].offsetLeft - slides[0].offsetLeft, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
    };
    thumbs.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.thumb))));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(index + 1));
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const next = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(track.clientWidth,1))));
        if (next !== index) { slides[index]?.querySelectorAll('video').forEach(video => video.pause()); index = next; }
        const counter = gallery.querySelector('[data-gallery-index]');
        if (counter) counter.textContent = String(index + 1);
        thumbs.forEach((button,i) => button.setAttribute('aria-current', String(i === index)));
      });
    }, { passive: true });
    gallery.querySelectorAll('[data-zoom]').forEach(link => link.addEventListener('click', event => {
      const dialog = gallery.querySelector('.zoom-dialog');
      if (!dialog?.showModal) return;
      event.preventDefault();
      const img = dialog.querySelector('[data-zoom-image]');
      img.src = link.href;
      img.alt = link.querySelector('img')?.alt || '';
      dialog.showModal();
    }));
  }
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    root.querySelectorAll('[data-gallery]').forEach(initGallery);
    if ('IntersectionObserver' in window && !reducedMotion.matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: .05 });
      root.querySelectorAll('[data-reveal]').forEach(el => {
        if (el.getBoundingClientRect().top > window.innerHeight + 50) { el.classList.add('reveal-ready'); observer.observe(el); }
      });
    }
  }
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close-dialog]');
    if (close) { const dialog = close.closest('dialog'); dialog.close(); if (dialog.id === 'CartDrawer') cartOpener?.focus(); }
    const opener = event.target.closest('[data-open-cart]');
    if (opener && document.getElementById('CartDrawer')?.showModal) { event.preventDefault(); openDrawer(opener); }
    const menu = document.querySelector('.mobile-nav');
    if (menu?.open && (!menu.contains(event.target) || event.target.closest('.mobile-nav a'))) menu.open = false;
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { const menu = document.querySelector('.mobile-nav'); if (menu?.open) { menu.open = false; menu.querySelector('summary').focus(); } } });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (cartBusy || !form.reportValidity()) return;
    const section = form.closest('[data-product-section]');
    const selected = selectedOffer(form);
    if (!selected || selected.disabled || selected.dataset.available !== 'true') { showError(form.querySelector('[data-product-error]'),config.strings.soldOut); return; }
    const error = form.querySelector('[data-product-error]');
    const recovery = form.querySelector('[data-cart-recovery]');
    if (error) error.hidden = true;
    if (recovery) recovery.hidden = true;
    const headers = {Accept:'application/json'};
    const data = new FormData(form);
    data.set('id',selected.value);
    data.set('quantity',selected.dataset.quantity || '1');
    data.set('sections','cart-drawer');
    data.set('sections_url',location.pathname);
    publish('add_to_cart_intent',{variant_id:selected.value,quantity:Number(selected.dataset.quantity),amount_minor:Number(selected.dataset.amount),currency:config.currency});
    cartBusy = true;
    form.querySelectorAll('[data-button-price]').forEach(el=>{el.textContent='';});
    cartOpener = event.submitter;
    form.setAttribute('aria-busy','true');
    section.querySelectorAll('[data-add-button],[data-sticky-button]').forEach(el => { el.disabled = true; });
    purchaseControls(section,form,'[data-button-label]','[data-sticky-label]').forEach(el => { el.textContent = config.strings.adding; });
    section.querySelectorAll('[data-sticky-button-price]').forEach(el=>{el.textContent='';});
    section.querySelectorAll('.offer-radio,[data-main-variant],[name="quantity"]').forEach(el => { el.dataset.wasDisabled = String(el.disabled); el.disabled = true; });
    let added = false;
    try {
      const response = await fetch(config.routes.add, { method:'POST', headers, body:data, credentials:'same-origin' });
      const result = await response.json();
      if (!response.ok || result.status) { showError(error,result.description || result.message || config.strings.error); if (recovery) recovery.hidden = false; return; }
      added = true;
      announce(config.strings.added);
      if (!replaceCart(result.sections?.['cart-drawer'])) {
        try { await refreshCart(); } catch { location.assign(config.routes.cart); }
      }
      const feedback=document.querySelector('[data-cart-feedback]');
      if(feedback){feedback.textContent=config.strings.addedVisible;feedback.hidden=false;}
    } catch {
      showError(error,added ? config.strings.added : config.strings.networkError);
      if (recovery) recovery.hidden = false;
    } finally {
      cartBusy = false;
      form.removeAttribute('aria-busy');
      section.querySelectorAll('[data-was-disabled]').forEach(el => { el.disabled = el.dataset.wasDisabled === 'true'; delete el.dataset.wasDisabled; });
      section.querySelectorAll('[data-product-form]').forEach(item => syncSelection(section,item));
    }
  });
  async function changeCart(key,quantity) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || !Number.isInteger(quantity) || quantity < 0) return;
    drawer.setAttribute('aria-busy','true');
    drawer.querySelectorAll('input,button[name="checkout"]').forEach(el => { el.disabled = true; });
    try {
      const response = await fetch(config.routes.change,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({id:key,quantity,sections:['cart-drawer'],sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || config.strings.cartError);
      if (!replaceCart(result.sections?.['cart-drawer'])) await refreshCart();
    } catch (error) {
      showError(document.querySelector('[data-cart-error]'),error.message || config.strings.cartError);
    } finally {
      const current = document.getElementById('CartDrawer');
      current?.removeAttribute('aria-busy');
      current?.querySelectorAll('input,button[name="checkout"]').forEach(el => { el.disabled = false; });
    }
  }
  document.addEventListener('change',event => {
    const input = event.target.closest('#CartDrawer [data-cart-key]');
    if (!input || !input.reportValidity()) return;
    const key = input.dataset.cartKey, quantity = Number(input.value);
    changeQueue = changeQueue.then(() => changeCart(key,quantity));
  });
  document.addEventListener('click',event => {
    const remove = event.target.closest('#CartDrawer [data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    const key = remove.dataset.cartRemove;
    changeQueue = changeQueue.then(() => changeCart(key,0));
  });
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => { event.target.querySelectorAll('[data-product-section]').forEach(section => section._taplyStickyCleanup?.()); });
  window.addEventListener('pageshow',event => { if (event.persisted) location.reload(); });
  init();
})();
